import React, { Fragment, useState } from "react";
import { TestimonialCollection } from "../components";
import { useFetchForm } from "../api/queries";
import { ScreenId } from "../types";
import { SEO } from "../components/seo";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WidgetConfig } from "@/types";
import { useGetSocialProofAssetById } from "@/features/testimonial-gallery/api/queries";

export interface CollectionPageProps {
  id: string;
}

export const TestimonialCollectionPage = ({ id }: CollectionPageProps) => {
  const [step, setStep] = useState<ScreenId>("welcome");
  const { data: form, isPending, isError } = useFetchForm(id);

  if (isPending) {
    return (
      <div className="testify-fixed testify-inset-0 testify-flex testify-items-center testify-justify-center testify-bg-gray-100">
        <div className="loader"></div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="testify-fixed testify-inset-0 testify-flex testify-flex-col testify-items-center testify-justify-center testify-bg-gray-100 testify-p-4">
        <div className="testify-flex testify-flex-col testify-items-center testify-gap-4 testify-text-center">
          <AlertCircle className="testify-h-12 testify-w-12 testify-text-red-500" />
          {/* <h1 className="testify-text-2xl testify-font-bold testify-text-gray-900">
          {error === 404
              ? "Form Not Found"
              : "Something went wrong"}
          </h1>
          <p className="testify-text-gray-600">
            {error === 404
              ? "The form you're looking for doesn't exist or has been deleted."
              : "We encountered an error while loading the form. Please try again."}
          </p> */}
          <Button
            onClick={() => window.location.reload()}
            className="testify-mt-4"
          >
            Try Again
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <SEO data={form!} />
      <TestimonialCollection step={step} onStepChange={setStep} data={form!} />
    </Fragment>
  );
};

export const CollectionFormComponentWidget: React.FC<WidgetConfig> = ({
  widgetId,
}) => {
  const { data, isPending } = useGetSocialProofAssetById<
    Record<string, string>
  >({ id: widgetId, refId: widgetId });

  if (!data || isPending) return <div></div>;

  return <TestimonialCollectionPage id={data.refId!} />;
};
